import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Resource } from "@/db/schema";
import Image from "next/image";
import { resourceColor } from "@/lib/resourceColor";
import { Avatar, AvatarFallback } from "./ui/avatar";

interface Props {
  resources: Resource[];
  onSelect: (resourceId: string) => void;
  selected: string | null;
}

export const SelectWithImage: React.FC<Props> = ({ resources, onSelect, selected }) => {
  return (
    <div className="space-y-2">
      <Select defaultValue={resources[0].id} onValueChange={(id) => onSelect(id)}>
        <SelectTrigger
          id="select-40"
          className="h-auto ps-2 [&>span]:flex [&>span]:items-center [&>span]:gap-2 [&>span_img]:shrink-0"
        >
          <SelectValue placeholder="Choose a resource" />
        </SelectTrigger>
        <SelectContent className="[&_*[role=option]>span]:end-2 [&_*[role=option]>span]:start-auto [&_*[role=option]]:pe-8 [&_*[role=option]]:ps-2">
          {resources.map((r) => (
            <SelectItem key={r.id} value={r.id}>
              <span className="flex items-center gap-2 max-w-[400px]">
                {r.imageId ? (
                  <div
                    className="relative w-10 h-10 rounded-md overflow-hidden shrink-0"
                    style={{ backgroundColor: resourceColor(r.name) }}
                  >
                    <Image
                      className="w-full h-full object-cover"
                      src={`https://${process.env.NEXT_PUBLIC_CLOUDFRONT_ID}.cloudfront.net/${r.imageId}`}
                      alt=""
                      width={40}
                      height={40}
                    />
                  </div>
                ) : (
                  <Avatar>
                    <AvatarFallback
                      style={{
                        backgroundColor: resourceColor(r.name),
                      }}
                    >
                      {r.name?.charAt(0)}
                    </AvatarFallback>
                  </Avatar>
                )}
                <span className="flex flex-col items-start overflow-hidden pr-4">
                  <span className="block font-medium select-none">{r.name}</span>
                  <span className="mt-0.5 block text-xs text-slate-70 select-none truncate w-full">
                    {r.description} - {r.capacity}
                  </span>
                </span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
